'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STANDALONE = exports.STANDALONE = 'STANDALONE';

var CONTAINER = exports.CONTAINER = 'CONTAINER';


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/~/@arreeba/ristoranti-lib/lib/constants/appType.js
// module id = 422
// module chunks = 0